<template>

  <div class="modal" v-bind:class="{ 'is-active' : isModalActive}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ CONSTANTS.getCopy('CONFIRMCOUNTDOWN_ATTENTION') }}</p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div>{{modalText}} {{countdown}} {{ CONSTANTS.getCopy('CONFIRMCOUNTDOWN_SECONDS') }}</div>

        <div class="field confirm-footer is-grouped-right">
          <div :class="[button, koStyle]" @click="cancel">
            <span class="icon"><i class="fas fa-times fa-lg"></i></span>
            <span>{{koText}}</span>
          </div>

        </div>

      </section>
    </div>
  </div>

</template>

<script>

export default {

  data () {
    return {
      showModal: false,
      modalText: 'Se procesará el envío en',
      time: 5,
      koText: 'Cancelar',
      button: 'button',
      koStyle: 'is-dark',
      countdown: 0,
      stop: true
    }
  },

  created () {
    Event.$on('showConfirmCountdown', () => {
      this.showModal = true
      this.time = 5
      this.countdown = 5
      this.stop = false
      this.updateClock()
    })
  },

  computed: {
    isModalActive () {
      return this.showModal
    }
  },

  methods: {
    updateClock () {
      if (!this.stop) {
        this.countdown = this.time
        if (this.time === 0 && this.showModal) {
          this.accept()
        } else {
          this.time--
          setTimeout(this.updateClock, 1000)
        }
      }
    },

    close () {
      this.showModal = !this.showModal
    },

    accept () {
      this.showModal = false
      Event.$emit('closeConfirmCountdown', true)
    },

    cancel () {
      this.showModal = false
      this.stop = true
      Event.$emit('closeConfirmCountdown', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/ConfirmCountdown.vue